module.exports = __webpack_public_path__ + "img/reference.9c2d541a.png";